import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";
import MqttService from "./MqttService";

const BASE_AUTOMATION_BUTTON = "access-control-service/automation-buttons";

const RESOURCES = {
	GET_ONE: (id) => `${BASE_AUTOMATION_BUTTON}/${id}`,
	LIST_AUTOMATION_BUTTON_BY_CONDOMINIUM_PAGINATED: (
		page,
		searchText,
		condominiumId,
		orderBy
	) =>
		`${BASE_AUTOMATION_BUTTON}/condominiums/${condominiumId}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	CREATE_AUTOMATION_BUTTON: () => BASE_AUTOMATION_BUTTON,
	DELETE_AUTOMATION_BUTTON: (automationButtonId) =>
		`${BASE_AUTOMATION_BUTTON}/${automationButtonId}`,
	UPDATE_AUTOMATION_BUTTON: (automationButtonId) =>
		`${BASE_AUTOMATION_BUTTON}/${automationButtonId}`,
	LIST_BY_CONDOMINIUM: (condominiumId) =>
		`${BASE_AUTOMATION_BUTTON}/condominiums/${condominiumId}`,
};

class AutomationButtonService {
	static async listAutomationButtonsByCondominiumPaginated(
		page,
		searchText,
		condominiumId,
		orderBy
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_AUTOMATION_BUTTON_BY_CONDOMINIUM_PAGINATED(
					page,
					searchText,
					condominiumId,
					orderBy
				)
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar comando de automação",
			});
			return error.response;
		}
	}

	static async listAutomationButtonsByCondominium(condominiumId) {
		try {
			return await axios.get(RESOURCES.LIST_BY_CONDOMINIUM(condominiumId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar comando de automação",
			});
			return error.response;
		}
	}

	static async getOne(id) {
		try {
			return await axios.get(RESOURCES.GET_ONE(id));
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter automação",
			});
			return error.response;
		}
	}

	static async createAutomationButton(payload) {
		try {
			const response = await axios.post(
				RESOURCES.CREATE_AUTOMATION_BUTTON(),
				payload
			);
			ResponseAlerts({
				response: response,
				successMessage: "Comando de automação cadastrado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao cadastrar comando de automação",
			});
			return error.response;
		}
	}

	static async updateAutomationButton(automationButtonId, payload) {
		try {
			const response = await axios.put(
				RESOURCES.UPDATE_AUTOMATION_BUTTON(automationButtonId),
				payload
			);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao editar comando de automação",
			});
			return error.response;
		}
	}

	static async deleteAutomationButton(automationButtonId) {
		try {
			const response = await axios.delete(
				RESOURCES.DELETE_AUTOMATION_BUTTON(automationButtonId)
			);
			ResponseAlerts({
				response: response,
				successMessage: "Comando de automação excluído com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao excluir comando de automação",
			});
			return error.response;
		}
	}
}

export default AutomationButtonService;
